import { loadMcpServers } from '../api/applications';
import { ResourceType } from '../types/ai-apps';
import { useResourcesStore } from 'vince-core/stores/resourcesStore';
import { Action } from 'vince-core/types/roles';
import type { ResourceItem } from 'vince-core/types/common';

export default defineNuxtPlugin(() => {
    const store = useResourcesStore();
    store.registerResource(ResourceType.MCP_SERVER.toString(), 'ai-apps.mcpServersMenu', [Action.WRITE, Action.READ], async () => {
        return await loadMcpServers().then((servers) => {
            return servers.map((it) => {
                return {
                    id: it.id,
                    key: it.id,
                    label: it.name,
                    description: it.systemPrompt,
                    resourceType: ResourceType.MCP_SERVER.toString(),
                    usable: true,
                    labels: []
                } as ResourceItem;
            });
        });
    }, 'pi pi-server');
});
